import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { MdEdit } from "react-icons/md";
import { Box, Button, styled, Dialog, DialogTitle, DialogActions, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CandidateOverviewAction } from '../../Redux/action/CandidateOverviewAction';
import { CandidateProfile } from "../../Redux/action/CandidateProfileAction";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
const CandidateOverview = (props) => {
  const { userResult } = useSelector((state) => state.Auth);
  const [open, setOpen] = useState(false);
  const [overview, setOverview] = useState("");

const id = props.data
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const candidateId = userResult?.userid;;

  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    e.preventDefault();
    let content = {
      candidateId,
      overview
    };

    dispatch(CandidateOverviewAction(content));
  };

  const userInfo = useSelector((state) => state.Profile.result);
  const overviewData = useSelector((state) => state.DashboardOverviewReducer.result);

  let userData = userInfo;

  useEffect(() => {
    if (userData) {
      setOverview({ ...userData });
    }
  }, [userData]);

  useEffect(()=>{
    setOpen(false);
    dispatch(CandidateProfile(id));
},[overviewData])

  const location = useLocation();
  return (
    <>
      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            Update Your Overview.
          </BootstrapDialogTitle>
          <form onSubmit={handleSubmit}>
            <Box
              sx={{
                width: 500,
                maxWidth: '100%',
              }}
            >
              <TextField fullWidth label="Overview" id="fullWidth" name="overview" value={overview.overview} onChange={(e) => setOverview(e.target.value)} />
            </Box>
            <DialogActions>
              <Button type="submit" autoFocus >
                Save changes
              </Button>
            </DialogActions>
          </form>
        </BootstrapDialog>
      </div>
      <div className="profile-card2" style={{overflowY:'scroll'}}>
        <div className='edit-button'>
          <div className='overview'>
            <span style={{ fontWeight: "bold" }}>Overview</span>
            {location.state === null ? <><span onClick={handleClickOpen}><MdEdit /></span></> : console.log("data")}
          </div>
        </div>
        <hr />
        <div className='para'>
          {userInfo.overview !== null && userInfo.overview !== "" ? <p>{userInfo.overview}</p> : <p className="Warning_data">Please Fill Your Overview</p>}
        </div>
      </div>
    </>
  )
}

export default CandidateOverview